import { useCallback, useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { useAuth } from '../context/AuthContext.jsx';
import { db } from '../../firebaseConfig.js';

export const useCurrentUserDoc = () => {
  const { user } = useAuth();
  const [userDoc, setUserDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchDoc = useCallback(async () => {
    if (!user?.uid) {
      setUserDoc(null);
      setLoading(false);
      setError('');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const snap = await getDoc(doc(db, 'users', user.uid));
      if (snap.exists()) {
        setUserDoc({ id: snap.id, ...snap.data() });
      } else {
        setUserDoc(null);
        setError('Profile not found.');
      }
    } catch (err) {
      console.error('[useCurrentUserDoc] Failed to load user doc', err);
      setUserDoc(null);
      setError('Failed to load profile.');
    } finally {
      setLoading(false);
    }
  }, [user?.uid]);

  useEffect(() => {
    fetchDoc();
  }, [fetchDoc]);

  return {
    uid: user?.uid || null,
    user,
    userDoc,
    loading,
    error,
    refetch: fetchDoc,
  };
};
